module.exports = __webpack_public_path__ + "static/media/Apartment.b947e7cc.svg";